﻿import definitions from '../Style/LfStyleDefinitions';

export default class FooterMenuHandler {
    constructor() {
        this.footerCl = 'footer__main-menu__item';
        this.activeCl = 'footer__main-menu__item__list--active';
        this.activeHeaderCl = 'footer__main-menu__item__heading--active';

        this.setupEventListeners();
    }

    setExpandedHeight = (container) => {
        if (container.classList.contains(this.activeCl)) {
            container.style.maxHeight = container.scrollHeight * 1.2 + 'px';
        } else {
            container.style.maxHeight = 0;
        }
    }

    resetExpandedHeight = (e) => {
        if (window.innerWidth > definitions.breaks.small) {
            let footerHeaderEls = document.querySelectorAll(`.${this.footerCl} h4`);
            footerHeaderEls.forEach(menuHeading => {
                let container = menuHeading.nextElementSibling;
                container.style.maxHeight = 'none';
            });

            window.removeEventListener('resize', this.resetExpandedHeight);
            window.addEventListener('resize', this.setupExpandedHeightEventListeners);
        }
    }

    setupExpandedHeightEventListeners = (e) => {
        if (window.innerWidth <= definitions.breaks.small) {
            let footerHeaderEls = document.querySelectorAll(`.${this.footerCl} h4`);
            footerHeaderEls.forEach(menuHeading => {
                let container = menuHeading.nextElementSibling;
                this.setExpandedHeight(container);
            });

            window.removeEventListener('resize', this.setupExpandedHeightEventListeners);
            window.addEventListener('resize', this.resetExpandedHeight);
        }
    }

    setupEventListeners = () => {
        let footerHeaderEls = document.querySelectorAll(`.${this.footerCl} h4`);

        if (window.innerWidth <= definitions.breaks.small) {
            window.addEventListener('resize', this.resetExpandedHeight);
        } else {
            window.addEventListener('resize', this.setupExpandedHeightEventListeners);
        }

        footerHeaderEls.forEach(menuHeading => {
            let container = menuHeading.nextElementSibling;

            if (window.innerWidth <= definitions.breaks.small) {
                this.setExpandedHeight(container);
            }

            menuHeading.addEventListener('click', e => {
                if (window.innerWidth <= definitions.breaks.small) {
                    menuHeading.classList.toggle(this.activeHeaderCl);
                    container.classList.toggle(this.activeCl);

                    this.setExpandedHeight(container);
                }
            });
        });
    }
}